import { defineNuxtPlugin } from '#app';
import Swiper from 'swiper/bundle'; // Use the bundle import
import 'swiper/css/bundle'; // Import all Swiper styles

export default defineNuxtPlugin((nuxtApp) => {
    // Provide $initSwiper function
    nuxtApp.provide('initSwiper', (el: HTMLElement | string, options: any) => {
        if (!el) {
            console.error('Element truyền vào initSwiper bị null');
            return null;
        }
        return new Swiper(el, options);
    });

    // Register v-swiper directive
    nuxtApp.vueApp.directive('swiper', {
        mounted(el: HTMLElement, binding: any) {
            const options = binding.value || {};
            // Store swiper instance on element for later access
            (el as any)._swiper = new Swiper(el, options);
        },
        updated(el: HTMLElement, binding: any) {
            // Optionally update swiper when options change
            if ((el as any)._swiper && binding.value !== binding.oldValue) {
                (el as any)._swiper.update();
            }
        },
        unmounted(el: HTMLElement) {
            // Destroy swiper on unmount
            if ((el as any)._swiper) {
                (el as any)._swiper.destroy(true, true);
                (el as any)._swiper = null;
            }
        }
    });
});

